interface AppConfig {
  RECAPTCHA_SITE_KEY: string;
  API_BASE_PATH: string;
  GA_MEASUREMENT_ID: string;
}

declare global {
  interface Window {
    __CONFIG__?: Partial<AppConfig>;
  }
}

export function getConfig(): AppConfig {
  const runtimeConfig = window.__CONFIG__ ?? {};

  return {
    RECAPTCHA_SITE_KEY:
      runtimeConfig.RECAPTCHA_SITE_KEY ?? import.meta.env.VITE_RECAPTCHA_SITE_KEY ?? "",
    API_BASE_PATH: runtimeConfig.API_BASE_PATH ?? import.meta.env.VITE_API_BASE_PATH ?? "",
    GA_MEASUREMENT_ID:
      runtimeConfig.GA_MEASUREMENT_ID ?? import.meta.env.VITE_GA_MEASUREMENT_ID ?? ""
  };
}
